// * Bootstrap libraries
import './_bootstrap';

(function ($, Drupal) {
  Drupal.behaviors.opcSortButtons = {
    attach: function (context, settings) {
      // Use Drupal's once() to bind click handlers only once per button after AJAX loads
      const $buttons = once('opc-sort-buttons', '[id^="sort-"]', context);

      $buttons.forEach(function (button) {
        $(button).on('keydown', function (event) {
            if (event.key === 'Enter') {
                const id = this.id;

                // Map icon ID to the appropriate sort field and order values
                let sortBy, sortOrder;

                switch (id) {
                    case 'sort-date-asc':
                    sortBy = 'field_publication_date';
                    sortOrder = 'ASC';
                    break;
                    case 'sort-date-desc':
                    sortBy = 'field_publication_date';
                    sortOrder = 'DESC';
                    break;
                    case 'sort-title-asc':
                    sortBy = 'title';
                    sortOrder = 'ASC';
                    break;
                    case 'sort-title-desc':
                    sortBy = 'title';
                    sortOrder = 'DESC';
                    break;
                    default:
                    return;
                }

                // Find the Views exposed form and update the sort fields
                const $form = $('#views-exposed-form-news-block-1, #views-exposed-form-news-block-2', context);
                $form.find('select[name="sort_by"]').val(sortBy);
                $form.find('select[name="sort_order"]').val(sortOrder);

                // Programmatically trigger the form submit button to reload the View via AJAX
                $form.find('input.js-form-submit').click();
            }
        });

        $(button).on('click', function () {
          const id = this.id;

          // Map icon ID to the appropriate sort field and order values
          let sortBy, sortOrder;

          switch (id) {
            case 'sort-date-asc':
              sortBy = 'field_publication_date';
              sortOrder = 'ASC';
              break;
            case 'sort-date-desc':
              sortBy = 'field_publication_date';
              sortOrder = 'DESC';
              break;
            case 'sort-title-asc':
              sortBy = 'title';
              sortOrder = 'ASC';
              break;
            case 'sort-title-desc':
              sortBy = 'title';
              sortOrder = 'DESC';
              break;
            default:
              return;
          }

          // Find the Views exposed form and update the sort fields
          const $form = $('#views-exposed-form-news-block-1, #views-exposed-form-news-block-2', context);
          $form.find('select[name="sort_by"]').val(sortBy);
          $form.find('select[name="sort_order"]').val(sortOrder);

          // Programmatically trigger the form submit button to reload the View via AJAX
          $form.find('input.js-form-submit').click();
        });
      });
    }
  };
     //external link to open in new tab
    $.expr[':'].external = function(obj){
      return !obj.href.match(/^mailto\:/)
            && (obj.hostname != location.hostname)
            && !obj.href.match(/^javascript\:/)
            && !obj.href.match(/^$/)
  };
  $('a:external').attr('target', '_blank');
})(jQuery, Drupal);




